module.exports = __webpack_public_path__ + "img/manchester-united.7d3ced87.png";